// extracted by mini-css-extract-plugin
module.exports = {"container":"Botonera_container__1pE3X","relativeContainer":"Botonera_relativeContainer__21Euk","isSelected":"Botonera_isSelected__2TxhZ"};